var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 530",
    style: {
      enableBackground: "new 0 0 720 530"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st64{opacity:6.000000e-02;fill:#00AFF0;enable-background:new    ;}\n\t.st65{opacity:0.12;fill:#0091EA;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_196",
    className: "st64",
    d: "M0,270.4C0,138.7,106.8,31.9,238.4,31.9s238.4,106.8,238.4,238.4 S370.1,508.8,238.4,508.8S0,402,0,270.4z M166.9,270.4c0,39.5,32,71.5,71.5,71.5s71.5-32,71.5-71.5s-32-71.5-71.5-71.5 S166.9,230.8,166.9,270.4L166.9,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_197",
    className: "st65",
    d: "M238.4,508.8L310,281.4C383.5,47.8,421.2,31.9,595.6,31.9h119.7 c-20,88.2-89.1,155.6-208.9,178.8c60.6,17.4,132.1,0,132.1,0C617.8,301.3,552,358.1,457.1,365c-37.6,87.3-123.5,143.8-218.5,143.8 H238.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBackground);
export default __webpack_public_path__ + "static/media/about-background.543a06b705e37c255f908d937fa43c24.svg";
export { ForwardRef as ReactComponent };